<template>
    <div class="full-width" v-loading="loading">
        <iframe :src="editorUrl" seamless="seamless" v-if="null != editorUrl" :style="styleObj" :class="(mobileFlag || fullScreen == false) ? 'mobile-iframe-box' : 'pc-iframe-box'"></iframe>
    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted, toRef, getCurrentInstance} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import cardApi from "@/request/api";
    import myUtil from "@/util/util";

    const props = defineProps(["companycode", "fullScreen"])

    const i18n = inject("i18n")
    const { proxy } = getCurrentInstance()

    const userInfoRef = toRef(useUserinfo())

    const editorUrl = ref(null)
    const loading = ref(true)

    const mobileFlag = ref(false)
    const styleObj = ref({})

    function getCompanyDefaultCard(){
        const request = cardApi.queryCompanyDefaultMemberWork
        const params = request.getParams()

        params.companycode = myUtil.isEmpty(props.companycode) ? userInfoRef.value.companycode : props.companycode

        request.send(params, (res) => {
            if (res.code == 200){
                loading.value = false
                editorUrl.value = `${proxy.$ShopopeeUrl}memberwork_editor?id=${res.detail.id}`
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    onBeforeMount(() => {
        if (null != props.companycode || null != userInfoRef.value.companycode){
            getCompanyDefaultCard()
        }

        mobileFlag.value = myUtil.isMobile()

        if (mobileFlag.value == true || props.fullScreen == false){
            const percent = 100 / 0.65

            styleObj.value = {
                width: `${percent}%`,
                height: `${percent}%`,
            }
        }
    })

    onMounted(() => {

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
    }

    .pc-iframe-box {
        width: 100%;
        height: 100%;
        border: none;
    }

    .mobile-iframe-box {
        transform-origin: 0 0;
        transform: scale(0.65);
        border: none;
    }
</style>